/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const BUTTON_STATE = {
    SHOW: 'Show All Meetings',
    HIDE: 'Hide Meetings'
};

/**
 * Component that is used for rendering Button, which change display state of cards
 * It displays different title regarding on state of CardsMatrix
 */
function CardsMeetingsBtn({ onClick, isExpanded }) {
    const btnText = isExpanded ? BUTTON_STATE.HIDE : BUTTON_STATE.SHOW;
    return (
        <button
            type="button"
            className="rh-cardsMeetingsBtn ui-btn"
            id="cardsMeetingsBtn"
            onClick={onClick}
        >
            <span className="rh-cardsMeetingsBtn__label">{btnText}</span>
            <Svg isInlined iconName="down" size="Medium" className="rh-cardsMeetingsBtn__icon" />
        </button>
    );
}

CardsMeetingsBtn.propTypes = {
    /**
     * Callback function, which is called, when user clicks on button
     */
    onClick: PropTypes.func.isRequired,
    /**
     * State of the cards matrix
     */
    isExpanded: PropTypes.bool.isRequired
};

export { CardsMeetingsBtn as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CardsMeetingsBtn/CardsMeetingBtn.js